export default __webpack_public_path__ + "static/media/10.429c069f.jpg";